import React from "react";
import {useTranslation} from "react-i18next";

import ValTab from "./valtab";

function Containers({data, onUpdate, simplified, dangerous, axis}) {

    const {t} = useTranslation();

    var headerStyle = {width: 60, maxWidth: 60, padding: 3, fontSize: "60%", align: "center"};

    return <ValTab
            title={t("Containers")}
            columns={[
                {title: t("Count"), field: "count", type: "numeric", min: 1, max: 100, initialEditValue: 1, width: 60, headerStyle: headerStyle},
                {title: t("Length"), field: "depth", type: "numeric", min: 1, max: 15000, width: 60, headerStyle: headerStyle},
                {title: t("Width"), field: "width", type: "numeric", min: 1, max: 15000, required: true, width: 60, headerStyle: headerStyle},
                {title: t("Height"), field: "height", type: "numeric", min: 1, max: 15000, width: 60, headerStyle: headerStyle},
                {title: t("Weight"), field: "weight", type: "numeric", hidden: simplified, width: 60, headerStyle: headerStyle},
                {title: t("Class"), field: "containerClass", type: "numeric", hidden: simplified, width: 60, headerStyle: headerStyle},
                {title: t("Risk"), field: "allowedRiskPoints", type: "numeric", hidden: !dangerous, width: 60, headerStyle: headerStyle},
                {title: t("Pos Front"), field: "posFront", type: "numeric", hidden: !axis, initialEditValue:1, xmax: 15000, width:60, headerStyle: headerStyle},
                {title: t("Empty Front"), field: "emptyFront", type:"numeric", hidden:!axis, initialEditValue:0, width:60, headerStyle: headerStyle},
                {title: t("Max Front"), field: "maxFront", type: "numeric", hidden: !axis, initialEditValue:0, headerStyle: headerStyle},
                {title: t("Pos Back"), field: "posBack", type: "numeric", hidden: !axis, initialEditValue:0, xmax: 15000, width:60, headerStyle: headerStyle},
                {title: t("Empty Back"), field: "emptyBack", type:"numeric", hidden:!axis, initialEditValue:0, width:60, headerStyle: headerStyle},
                {title: t("Max Back"), field: "maxBack", type: "numeric", hidden: !axis, initialEditValue:0, headerStyle: headerStyle},
                {title: t("Cost"), field: "cost", type: "numeric", initialEditValue: 1, hidden: true},
                {title: t("Used"), field: "used", editable: "never", width: 60, headerStyle: headerStyle},
                {title: t("Filled"), field: "filled", editable: "never", width: 60, headerStyle: headerStyle}
                ]}
            data={data}
            onUpdate={onUpdate}
            singleRow={simplified}
            />;
    }


export default Containers;